var alpha_cached = '';
var footer_cached = '';
var first_hp_slide_load = true;
var prev_slide = 1;

function init_mobile_slider()
{
    //INIT FLEXSLIDER IF NON-EXISTENT
    var flexslider_instance = $('#container').data('flexslider');
    if(flexslider_instance == undefined){

        //alert('init flexslider');

        //SORT COLUMNS FOR FLEXSLIDER POSITIONS
        //alpha_cached = $('.alpha-container').html();
        //$('#container .gamma').after(alpha_cached);

        //MOVE LATEST POLLS UP ON MOBILE ONLY
        // Disabled 5/7/2019
        //mobile_polls_interval = setInterval(move_polls_widget_when_visible, 2000);

        $('.alpha-container').insertAfter('#container .gamma');

        var starting_slide = 1; // middle col
        // get breaking news hash if exists
        if(window.location.hash) {
            var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
            if(hash == 'breaking_news') {
                starting_slide = 0; // left col
            }
        }

        let slider_start    = new Event('hp_slider_start');
        let slider_after    = new Event('hp_slider_after');
        let slider_before   = new Event('hp_slider_before');

        $('#container').flexslider({
            container_exists: first_hp_slide_load, // Assumes flex-viewport is there already
            selector: ".mobile-slider > .tab",
            slideshow: false,
            slideshowSpeed: 0,
            animation: "slide",
            controlNav: false,
            startAt:starting_slide,
            smoothHeight:false,
            slideshowSpeed:500,
            prevText: "<img src='/asset/img/icon-arrow-left-white.png' />",
            nextText: "<img src='/asset/img/icon-arrow-right-white.png' />",
            start: function(slider){

                //$('.clone .RC-AD > div').attr('id', '');

                console.log('main slider started');
                //move foter wrapper down
                footer_cached = $('.footer-wrapper').html();
                //$('.flex-control-nav').after(footer_cached);
                //$('.footer-wrapper').show();
                $('.footer-wrapper').insertAfter( $('#container > ul.flex-direction-nav') ).show();

                //mobile nav arrows
                $( ".mobile-nav-wrapper a.arrows" ).on('click', function(e){
                    e.preventDefault();
                    if($(this).attr("rel")=="prev"){
                        $('#container > ul.flex-direction-nav > li > .flex-prev').trigger('click');
                    }else if($(this).attr("rel")=="next"){
                        $('#container > ul.flex-direction-nav > li > .flex-next').trigger('click');
                    }
                });


                //HOMEPAGE MOBILE NAV MENU ITEMS
                $( ".mobile-nav-wrapper a" ).click(function(e){

                    // Prevent a page reload when a link is pressedv
                    e.preventDefault();

                    if($(this).hasClass("arrows")==false){

                        //remove class from all then add active class back to active link - controls border bottom visual
                        $(".mobile-nav-wrapper a").removeClass('active');
                        $( this ).addClass('active');

                        // Call the scroll function
                        // alert($(this).attr("rel"));


                        //var slider = $('#container').data('flexslider');
                        //alert( $(this).attr("rel") );
                        var gotoslide = parseInt($(this).attr("rel"));
                        //alert(gotoslide);
                        slider.flexAnimate(gotoslide);
                    }


                });

                //ELECTION CENTRAL WIDGET CONTAINER CLICK -> GOTO LATEST POLLS COLUMN
                $("#election_central_hp_widget").click(function(e){
                    e.preventDefault();
                    slider.flexAnimate(2);
                });

                document.dispatchEvent(slider_start);
            },
            after: function(slider){
                //update mobile menu to hightlight current slide
                if(siteName == 'markets' ){
                    ic_render_mobile_ads(); //UAT for mobile
                }

                var currentslide = slider.currentSlide;
                $('.mobile-nav-wrapper a').each(function(index){
                    $(this).removeClass("active");
                    if( $(this).attr('rel')==currentslide ){
                        $(this).addClass("active");
                    }
                });
                //console.log('slider.currentSlide: '+slider.currentSlide);
                //console.log(slider);
                // Send GA Event
                var slide_name = '';
                if(currentslide == 0) {
                    slide_name = 'gamma';
                } else if(currentslide == 1) {
                    slide_name = 'alpha';
                } else if(currentslide == 2) {
                    slide_name = 'beta';
                }
                var prev_slide_name = '';
                if(prev_slide == 0) {
                    prev_slide_name = 'gamma';
                } else if(prev_slide == 1) {
                    prev_slide_name = 'alpha';
                } else if(prev_slide == 2) {
                    prev_slide_name = 'beta';
                }
                if(slide_name != prev_slide_name) {

                    var event_data = {
                        'ge_action' : 'Slide',
                        'ge_category' : 'HP Mobile Pane Switcher',
                        'ge_label' : 'from '+prev_slide_name+' to '+slide_name,
                        'ge_noninteraction' : false
                    };
                    send_ga_event(event_data);
                }

                prev_slide = currentslide;
                //loadAds();

                document.dispatchEvent(slider_after);
            },
            before: function(slider){
                //EVERYTIME YOU SWITCH SLIDES THIS WILL TAKE YOU AUTOMATICALLY TO THE TOP OF THE ONE YOU SLID TO
                $("html, body").animate({ scrollTop: 0 }, "slow");
                document.dispatchEvent(slider_before);
            }

            //RE-TRIGGER GA DIV CONTAINER AND AD-SLOT PUSH 
            //loadAds();				

        });

        first_hp_slide_load = false;


        // Reset battle widget slider
        var bw_flex = $('.beta-container:not(.clone) #small_rectangles_election_wrapper').data('flexslider');
        if(typeof bw_flex !== 'undefined') {

            console.log('destroy flex for battle widget');
            bw_flex.destroy();
            gmur_interval = setInterval(init_slider_when_visible, 1000);
        }

    }
}

export default init_mobile_slider;